export default "__VITE_ASSET__CrRIFMuO__"